import React from "react";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";

const ContactInfo: React.FC = () => (
  <div>
    <h2 className="text-ink-black mb-4 font-semibold text-lg">Contact Us</h2>
    <div className="mb-4">
      <div className="flex items-start space-x-2 mb-2">
        <div>
          <p className="font-medium text-ink-black mb-1 text-sm">Address:</p>

          {/* Desktop & Tablet (md and up) */}
          <p className="hidden md:flex items-center text-ink-gray text-sm space-x-2 ml-4">
            <MapPin className="w-4 h-4 text-coral-pink-500 flex-shrink-0" />
            <span>Dhanmondi 27, Dhaka</span>
          </p>

          {/* Mobile (less than md) */}
          <div className="block md:hidden text-ink-gray text-sm leading-relaxed ml-4">
            <p className="flex items-center space-x-2">
              <MapPin className="w-4 h-4 text-coral-pink-500 flex-shrink-0" />
              <span>Dhanmondi 27, Dhaka</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <p className="font-medium text-ink-black mb-2 text-sm">Contact:</p>
      <div className="space-y-2 ml-4">
        <a
          href="tel:+8809613827464"
          className="flex items-center space-x-2 hover:text-coral-pink-500 transition-colors duration-200 group"
        >
          <Phone className="w-4 h-4 text-coral-pink-500 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
          <p className="text-ink-gray text-sm group-hover:text-coral-pink-500">
            Call us: +8809613827464
          </p>
        </a>
        <a
          href="mailto:info@travela.xyz"
          className="flex items-center space-x-2 hover:text-coral-pink-500 transition-colors duration-200 group"
        >
          <Mail className="w-4 h-4 text-coral-pink-500 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
          <p className="text-ink-gray text-sm group-hover:text-coral-pink-500">
            Email: info@travela.xyz
          </p>
        </a>
        <a
          href="https://wa.me/8801901358957"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center space-x-2 hover:text-coral-pink-500 transition-colors duration-200 group"
        >
          <MessageCircle className="w-4 h-4 text-coral-pink-500 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" />
          <p className="text-ink-gray text-sm group-hover:text-coral-pink-500">
            WhatsApp: +8801901358957
          </p>
        </a>
      </div>
    </div>
  </div>
);

export default ContactInfo;
